import React, { useState } from "react";
import { Layout } from "../../components/Layout/Layout";
import { useAuthUser } from "react-auth-kit";
import CurrenciesTable from "./CurrenciesTable";

const Currencies = () => {
    const auth = useAuthUser();
    const taps = ['Currencies']
    return (
        <Layout>
            <div className="mt-[0px] mx-[2%]">
                <div className="text-[16px] font-semibold text-[#797979] ">Currencies</div>

                <div className="text-[28px] font-semibold  " style={{ fontFamily: "gilroy-bold" }}>
                    Currencies
                </div>

                <div>
                    <CurrenciesTable />
                </div>
            </div>
        </Layout>
    );
};

export default Currencies;
